Vue.component('ack-brands-slider', {
  delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
  template: '#ack-brands-slider',
  created() {
    console.log('ack-brands-slider created')
    
    // if(this.isMobile){
    //   this.carouselOptions.slidesToShow = 3
    // }
    
  },
  mounted() {
    console.log('ack-brands-slider mounted')
    
    
  },
  props:{
    brands: {
      type: Array,
      required: true
    },
    isMobile: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    //...Vuex.mapGetters('navBar', ['switchMobileDropdowns']),

    showedBrands(){
      let obj = {}
      for (let index = 0; index < this.brands.length; index++) {
        const element = this.brands[index]
        obj[element] = true
      }
      return obj
    },

    carouselOptions(){
      let opt = {
        arrows: false,
        dots: false,
        infinite: true,
        slidesToShow: this.isMobile? 3 : 5,
        slidesToScroll: 1,
        autoplay: true,
        speed: 3000,
        autoplaySpeed: 0,
        cssEase: 'linear'
      }

      return opt
    }

  },
  data() {
    return {
      // carouselOptions: {
      //   arrows: false,
      //   dots: false,
      //   infinite: true,
      //   slidesToShow: 5,
      //   slidesToScroll: 1,
      //   autoplay: true,
      //   speed: 3000,
      //   autoplaySpeed: 0,
      //   cssEase: 'linear'
      // }
    }
  },
  methods: {
    //...Vuex.mapActions(['sayHi', 'someAction']),
    //...Vuex.mapActions('navBar', ['sayHi', 'closeAllMobileDropdowns'])   

  },
  beforeDestroy() {
    
  },
  watch: {
    isMobile: {
      handler() {
        
        
      },
      deep: false
    }
  }
})